import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_lara-b-acessorios/artifacts/a4dc1f7112ea5d2a_IMG_3303.webp";

export default function Logo({ size = "md", to = "/", variant = "light" }) {
  const h = size === "lg" ? "h-20 sm:h-24 md:h-28" : size === "sm" ? "h-10 sm:h-12" : "h-14 sm:h-16 md:h-20";
  // On dark backgrounds (admin sidebar/login) show it inside a white rounded pill so the balloon letters pop.
  const wrapper =
    variant === "dark"
      ? "shrink-0 inline-flex items-center bg-white rounded-2xl px-3 py-2 shadow-sm hover:scale-105 transition-transform"
      : "shrink-0 inline-flex items-center hover:scale-105 transition-transform";
  return (
    <Link to={to} data-testid="logo-link" className={wrapper}>
      <img
        src={LOGO_URL}
        alt="Lara B."
        className={`${h} w-auto object-contain select-none`}
        draggable={false}
      />
    </Link>
  );
}
